// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { HOME_SET_AT_MASTERS_DATA } from './constants';

export function setAtMastersData(data) {
  return {
    type: HOME_SET_AT_MASTERS_DATA,
    data: data,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SET_AT_MASTERS_DATA:
      if (action.data && action.data.type && action.data.type === 'terminals') {
        return {
          ...state,
          atTerminals: action.data.data,
        };
      } else if (action.data && action.data.type && action.data.type === 'block_time') {
        return {
          ...state,
          atBlockTime: action.data.data,
        };
      } else
        return {
          ...state,
          atMastersData: action.data,
        };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/setAtMastersData.js